var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_4_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "beard_x5F_4_1_",
    fill: "#862618",
    d: "M458.7,321.7c-0.2-9.5-1.6-19.2-2.8-28.7c-1.3-9.3-2.2-18.7-4.6-27.7 c-2.5,18.2-3.2,36.2-8.7,53.9c-2.7,8.6-8.5,14.6-14.2,21.3c-6,7.1-12.2,13.8-18.9,20.2c-0.7-6.3-1-12.7-2-19 c-0.8-5.2-8.8-7.7-13.2-9.3c-3.4-1.3-6.1-2-9.7-2.9c-1.9-0.4-5.5,3-7.4,4.1c-5.4,3.2-10.8,4.5-17,5.1c-7.7,0.1-12.6-1.4-18.1-4.5 c-1.6-0.9-4.6-3.7-6.7-5.5c-0.4-0.3-2.3,0.2-2.7,0.3c-3.5,1-6.2,1.7-9.6,3c-4.4,1.6-12.4,4.7-15.6,8.9c-3.6,4.8-3.5,13.2-3.3,19.5 c-6.3-7.2-9.3-11.4-14.2-19.3c-5-7.9-12.5-19.9-15.2-28.5c-5.6-17.7-6-29.8-6.9-47.2c-2.4,9.1-3.4,15.9-4.7,25.2 c-1.3,9.4-2.1,21.5-2.3,31c-0.2,9.3,0,24.9,4.6,33.3c4.8,8.9,8.2,11.5,14.7,19.2c6.1,7.2,14,13.2,20.7,19.9 c6.7,6.5,16.1,14.6,23.8,20c4,2.9,5.8,3.6,11,3.5s10.4-0.2,15.6,0c2.2,0.1,8.1-0.1,10.3-0.1c2.2,0,4.4,0,6.6-0.1 c5.2-0.2,10.2-0.3,15.4-0.2c5.1,0.1,9.1-2.1,13.1-4.9c7.6-5.5,14.3-12.7,20.9-19.3c6.7-6.6,13.3-13.3,19.4-20.5 c6.5-7.7,12.7-15.2,17.5-24.1C459,339.8,458.9,331.1,458.7,321.7z M401.2,360.6c-0.5,4.9-0.6,9.7-3.5,13.9 c-2.5,3.7-6.8,6.2-10.4,8.6c-3.3,2.2-9,6.1-12.1,2.2c-2.1-2.7-4.4-9.1-8.1-9.3c-2.6-0.2-5.3,0.1-7.9,0.2l0,0 c-2.1,0.1-4.1,0.4-6.2,0.5c-3.7,0.3-5,6.8-8.6,9.3c-4.1,2.9-12.1,0.2-15.8-1.3c-4.4-1.9-9.7-4.1-12.2-7.7 c-2.9-4.2-2.7-11.2-2.4-16.2c0.2-4.4,0.4-6.5,0.9-10.9c0.6-5.1,4.7-5.2,13.6-5.7c10.3-0.6,21.5-1.8,31.8-2 c10.2,0.1,20.3-0.2,30.4,0.1c4.1,0.1,9.2-0.4,9.9,4.8C400.9,351.3,401.7,356.2,401.2,360.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard4A);
export default __webpack_public_path__ + "static/media/man_beard_4a.627f2d49c7aae675b624e4f4171d8e4f.svg";
export { ForwardRef as ReactComponent };